var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M5.5 0L10.2631 5.25L0.73686 5.25L5.5 0Z",
    fill: "#FB263B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon3);
export default __webpack_public_path__ + "static/media/Polygon 3.58856cd044da7c6b6b424b8cf7087e0f.svg";
export { ForwardRef as ReactComponent };